import React, { ReactElement } from 'react';
import { PanelGrid } from '../../../../../PanelGrid';
import { buildPanelGridDemoData } from '../../buildPanelGridConfigs/buildPanelGridDemoData/buildPanelGridDemoData';

export type SessionInformationPanelGridProps = {
  sessionInformation: SessionInformation;
  isApexDemo: boolean;
};

export function SessionInformationPanelGrid({
  sessionInformation,
  isApexDemo,
}: SessionInformationPanelGridProps): ReactElement {
  if (isApexDemo) return <></>;

  return (
    <PanelGrid
      data={buildPanelGridDemoData(sessionInformation)}
      wideCol="value"
      nameBold={true}
    />
  );
}
